import React, { useState } from "react";
import * as ReactBootStrap from "react-bootstrap";
import "./Esign.css"
const states = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttarakhand',
  'Uttar Pradesh',
  'West Bengal'
];

function Esign() {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [formData, setFormData] = useState({});
  const [showInput, setShowInput] = useState(false);
  const toggleInput = () => {
    setShowInput(prevState => !prevState);
  }
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    setIsLoading(true);
    setErrorMessage(null);
    event.preventDefault();
    const payloaded = {
      data: {
        ...formData,
        type: event.target.elements.type.value,
        coordinate: event.target.elements.coordinate.value,
        pdf: "",
        presigned_reference_no: formData.presigned_reference_no,
        request_id: "1234"
      },
    };

    const response = await fetch(
      "https://dnf65oncc2.execute-api.ap-south-1.amazonaws.com/default/lmbd_ainxt_emudhra_demo_security_request",
      {
        method: "POST",
        headers: {
          "x-api-key": "7EbZvRYBb91kW83bWzB509hRf9mmPOi39EIjPpKN",
        },
        body: JSON.stringify(payloaded),
      }
    );
    const data = await response.json();
    console.log(data.body, "THIS IS BODY");
    const payload = {
      source: "ainxt",
      vendor: "edh_eig",
      data: data.body,
    };
    fetch(
      "https://s89a50mfw8.execute-api.ap-south-1.amazonaws.com/v1/esign/request",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "09UcrsJ7RV4qO7hDK8GCD3QkXQr4QTcch5W3RWF9",
        },
        body: JSON.stringify(payload),
      }
    )

      .then((response) => response.json()
      )
      .then((secondApiData) => {
        console.log(secondApiData.data, "THIS IS SECONDAPI DATA")
        if (secondApiData.data !== undefined && secondApiData.data !== null) {
          // window.location.href = secondApiData.data;
        }
        else if (secondApiData.url == undefined && secondApiData.url == null) {
          alert(secondApiData.data.message);
          setErrorMessage(secondApiData.data.message);
        } else if (secondApiData.data.message) {
          alert(secondApiData.data.message);
          setErrorMessage(secondApiData.data.message);
        } else {
          alert("Unknown Error Occurred!");
        }
      })
      .then((secondApiData) => console.log(secondApiData))
      .catch((error) => console.error(error));
    setIsLoading(false);
  };


  return (
    <div className="container esign containerBoreder">
      <h2 className="pageTitle">Esign</h2>
      <form className="" onSubmit={handleSubmit}>
        {errorMessage && <div>{errorMessage}</div>}
        {isLoading && <ReactBootStrap.Spinner animation="border" />}
        <div className="row marginRow">
          <div className="col-sm-4">
            <div className="form-group">
              <label>Signer's Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                className="form-control"
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>State</label>
              <select
                type="text"
                name="state"
                value={formData.state}
                onChange={handleInputChange}
                required
                className="form-control"
              >
                <option value="">Select state</option>
                {states.map((state) => (
                  <option key={state} value={state}>{state}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>Reason</label>
              <input
                type="text"
                name="reason"
                value={formData.reason}
                onChange={handleInputChange}
                required
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="row marginRow">
          <div className="col-sm-8">
            <div className="form-group">
              <label>Co-ordinates</label>
              <div>
                <textarea
                  type="text"
                  name="coordinate"
                  value={formData.coordinates}
                  onChange={handleInputChange}
                  className="form-control"
                />
                <input
                  type="hidden"
                  name="coordinatesValue"
                  value={formData.coordinates}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>Type </label>
              <select
                name="type"
                value={formData.type}
                onChange={handleInputChange}
                className="form-control"
              >
                <option onChange={handleInputChange} value="pan">
                  Pan
                </option>
                <option onChange={handleInputChange} value="adhaar">
                  Adhaar
                </option>
                <option onChange={handleInputChange} value="Biometric">
                  Biometric
                </option>
              </select>

            </div>
          </div>
        </div>
        <div className="row marginRow">
          <div className="col-sm-4">
            <div className="form-group">
              <label>{showInput ? 'request_id' : 'presigned_reference_no'}</label>
              <input
                type="text"
                name={showInput ? 'request_id' : 'presigned_reference_no'}
                value={showInput ? formData.request_id : formData.presigned_reference_no}
                onChange={handleInputChange}
                required
                className="form-control"
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>Source</label>
              <input
                type="text"
                name="source"
                value={formData.source}
                onChange={handleInputChange}
                required
                className="form-control"
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>Redirect URL</label>
              <input
                type="text"
                name="redirect_url"
                value={formData.redirect_url}
                onChange={handleInputChange}
                required
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="row marginRow">
          <div className="col-sm-4">
            <button
              onClick={toggleInput}
              style={{
                margin: '10px 0',
                padding: '8px 15px',
                cursor: 'pointer',
                backgroundColor: '#ef4f28',
                color: 'white',
                border: 'none',
                borderRadius: '4px'
              }}>
              {showInput ? 'Hide' : 'Show'} Input
            </button>
            {showInput && (
              <div>
                <label>Upload PDF</label>
                <input
                  type="file"
                  name="pdf"
                  onChange={(e) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(e.target.files[0]);
                    reader.onload = () => {
                      const base64String = reader.result.split(",")[1];
                      console.log("Base64 string:", base64String);
                      setFormData((prevState) => ({ ...prevState, pdf: base64String }));
                    };
                  }}
                  required
                  className="form-control"
                />
              </div>
            )}
          </div>
          <div className="col-sm-8 text-right">
            <button className="btn btn-primary mob-w-100 " type="submit">Submit</button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Esign;